var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-form",
        {
          ref: "listForm",
          staticClass: "listForm",
          attrs: {
            model: _vm.listForm,
            rules: _vm.rules,
            "label-width": "160px",
          },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "卡片名称", prop: "name" } },
            [
              _c("el-input", {
                attrs: {
                  maxlength: "99",
                  size: "small",
                  placeholder: "请输入卡片名称",
                  clearable: "",
                },
                model: {
                  value: _vm.listForm.name,
                  callback: function ($$v) {
                    _vm.$set(_vm.listForm, "name", $$v)
                  },
                  expression: "listForm.name",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "卡片标题", prop: "title" } },
            [
              _c("el-input", {
                attrs: {
                  maxlength: "99",
                  size: "small",
                  placeholder: "请输入卡片标题",
                  clearable: "",
                },
                model: {
                  value: _vm.listForm.title,
                  callback: function ($$v) {
                    _vm.$set(_vm.listForm, "title", $$v)
                  },
                  expression: "listForm.title",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "卡片描述", prop: "description" } },
            [
              _c("el-input", {
                attrs: {
                  maxlength: "99",
                  size: "small",
                  placeholder: "请输入卡片描述",
                  clearable: "",
                },
                model: {
                  value: _vm.listForm.description,
                  callback: function ($$v) {
                    _vm.$set(_vm.listForm, "description", $$v)
                  },
                  expression: "listForm.description",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "频道", prop: "channelItems" } },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small" },
                  on: { click: _vm.showChannelDialog },
                },
                [_vm._v("添加频道")]
              ),
              _vm.listForm.channelItems && _vm.listForm.channelItems.length
                ? _c(
                    "avue-crud",
                    {
                      ref: "crud",
                      staticStyle: { width: "100%" },
                      attrs: {
                        option: _vm.option,
                        data: _vm.listForm.channelItems,
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "coverImg",
                            fn: function ({ row }) {
                              return [
                                row.coverImg
                                  ? _c("el-image", {
                                      staticStyle: {
                                        width: "100px",
                                        height: "100px",
                                      },
                                      attrs: {
                                        src: row.coverImg,
                                        fit: "scale-down",
                                      },
                                    })
                                  : _c("span", [_vm._v("暂无图片")]),
                              ]
                            },
                          },
                          {
                            key: "medias",
                            fn: function ({ row }) {
                              return [
                                _c("span", [
                                  _vm._v(_vm._s(row.contentList.length || "")),
                                ]),
                              ]
                            },
                          },
                          {
                            key: "menu",
                            fn: function ({ row }) {
                              return [
                                _c(
                                  "el-button",
                                  {
                                    attrs: {
                                      type: "text",
                                      size: "small",
                                      disabled: !_vm.canMoveUp(
                                        _vm.listForm.channelItems,
                                        row
                                      ),
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.moveUp(row)
                                      },
                                    },
                                  },
                                  [_vm._v("\n            上移\n          ")]
                                ),
                                _c(
                                  "el-button",
                                  {
                                    attrs: {
                                      type: "text",
                                      size: "small",
                                      disabled: !_vm.canMoveDown(
                                        _vm.listForm.channelItems,
                                        row
                                      ),
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.moveDown(row)
                                      },
                                    },
                                  },
                                  [_vm._v("\n            下移\n          ")]
                                ),
                                _c(
                                  "el-button",
                                  {
                                    attrs: {
                                      type: "text",
                                      size: "small",
                                      disabled: !_vm.canMoveTop(
                                        _vm.listForm.channelItems,
                                        row
                                      ),
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.moveTop(row)
                                      },
                                    },
                                  },
                                  [_vm._v("\n            置顶\n          ")]
                                ),
                                _c(
                                  "el-button",
                                  {
                                    attrs: { type: "text", size: "small" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.editChannel(row)
                                      },
                                    },
                                  },
                                  [_vm._v("编辑")]
                                ),
                                _c(
                                  "el-button",
                                  {
                                    staticStyle: { color: "#f56c6c" },
                                    attrs: { type: "text", size: "small" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.delChannel(row)
                                      },
                                    },
                                  },
                                  [_vm._v("删除")]
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        3955865201
                      ),
                    },
                    [_c("template", { slot: "mySearch" })],
                    2
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "备注", prop: "remark" } },
            [
              _c("el-input", {
                attrs: {
                  "show-word-limit": "",
                  maxlength: "9999",
                  type: "textarea",
                  size: "small",
                  placeholder: "请输入备注",
                  clearable: "",
                },
                model: {
                  value: _vm.listForm.remark,
                  callback: function ($$v) {
                    _vm.$set(_vm.listForm, "remark", $$v)
                  },
                  expression: "listForm.remark",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "状态", prop: "status" } },
            [
              _c(
                "el-radio-group",
                {
                  model: {
                    value: _vm.listForm.status,
                    callback: function ($$v) {
                      _vm.$set(_vm.listForm, "status", $$v)
                    },
                    expression: "listForm.status",
                  },
                },
                [
                  _c("el-radio", { attrs: { label: 1 } }, [_vm._v("生效")]),
                  _c("el-radio", { attrs: { label: 0 } }, [_vm._v("失效")]),
                ],
                1
              ),
            ],
            1
          ),
          _vm.listForm.status === 1
            ? _c(
                "el-form-item",
                { attrs: { label: "选择", prop: "effectMode" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.listForm.effectMode,
                        callback: function ($$v) {
                          _vm.$set(_vm.listForm, "effectMode", $$v)
                        },
                        expression: "listForm.effectMode",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: 1 } }, [
                        _vm._v("立即生效"),
                      ]),
                      _c("el-radio", { attrs: { label: 2 } }, [
                        _vm._v("指定时间生效"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.listForm.status === 1 && _vm.listForm.effectMode === 2
            ? _c(
                "el-form-item",
                { attrs: { label: "生效时间", prop: "effectTime" } },
                [
                  _c("el-date-picker", {
                    attrs: {
                      size: "small",
                      "picker-options": {
                        disabledDate(time) {
                          return time.getTime() < Date.now() - 8.64e7
                        },
                      },
                      "value-format": "yyyy-MM-dd HH:mm:ss",
                      type: "datetimerange",
                      "range-separator": "至",
                      "start-placeholder": "生效开始时间",
                      "end-placeholder": "生效结束时间",
                      clearable: "",
                    },
                    model: {
                      value: _vm.listForm.effectTime,
                      callback: function ($$v) {
                        _vm.$set(_vm.listForm, "effectTime", $$v)
                      },
                      expression: "listForm.effectTime",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "btn-container",
          staticStyle: { "text-align": "right", "margin-top": "20px" },
        },
        [
          _c(
            "el-button",
            {
              attrs: { size: "small", type: "primary" },
              on: { click: _vm.saveCard },
            },
            [_vm._v("保存")]
          ),
          _c(
            "el-button",
            { attrs: { size: "small" }, on: { click: _vm.cancel } },
            [_vm._v("取消")]
          ),
        ],
        1
      ),
      _c("ChannelSelect", {
        ref: "channelSelect",
        on: { save: _vm.getChannel },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }